import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Fragment } from 'react'
import { map, pick } from 'lodash'
import classNames from "classnames";
import TagOwnerImageFormField from "./form_fields/tag_owner_image_form_field"
import RadioButton from "./form_fields/radio_button"
import Dropdown from "./form_fields/dropdown"
import Datepicker from "./form_fields/datepicker"
import Timepicker from "./form_fields/timepicker"
import Corona3gDatetimeField from "./form_fields/corona_3g_datetime_field"
import FixedValue from "./form_fields/fixed_value"
import Textfield from "./form_fields/textfield"
import { useFormContext } from "react-hook-form";
import Phone from "./form_fields/phone";
import PinturaImageTag from "./form_fields/pintura_image_tag";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import TextArea from './form_fields/textarea';

const FormField = ({ type, field, tagOwner, formMode }) => {
  switch (type) {
    case "Radio Buttons":
      return (
        <RadioButton tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Dropdown":
      return (
        <Dropdown tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Datepicker":
      return (
        <Datepicker tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Datetimepicker":
      return (<div className="alert alert-danger">Not Implemented</div>)
    case "Timepicker":
      return (
        <Timepicker tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Corona-3G-Datetime-Field":
      return (
        <Corona3gDatetimeField tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Tag Owner Image":
    case "tag_owner_image_file_pond":
    case "tag_owner_image_uppy":
      return (
        <TagOwnerImageFormField tagOwner={tagOwner} field={field} formMode={formMode} type={type} />
      )
    case "tag_owner_image_pintura":
      return <PinturaImageTag tagOwner={tagOwner} field={field} formMode={formMode} type={type} />
    case "Phone":
      return (
        <Phone tagOwner={tagOwner} field={field} formMode={formMode} type={type} />
      )
    case "Fixed Value":
      return (
        <FixedValue tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    case "Text area":
      return (
        <TextArea tagOwner={tagOwner} field={field} formMode={formMode} />
      )
    default:
      if ((type == "Text field" && field == "email") || type == "Email field") {
        type = "email"
      } else if (type == "Number field") {
        type = "number"
      } else if (type == "phone_number_parent") {
        type = "tel"
      }
      return (
        <Textfield tagOwner={tagOwner} field={field} formMode={formMode} type={type} />
      )
  }
}
const FormFields = function ({ tagOwner, ...props }) {
  const formMode = props.fieldType
  const visible_fields = useSelector(state => state[formMode].ignored_fields)
  const all_field_types = useSelector(state => state[formMode].field_types)
  const field_positions = useSelector(state => state[formMode].field_positions)
  const formFieldStyle = useSelector(state => state.form_field_style)

  const inputFields = pick(all_field_types, Object.keys(visible_fields).sort((a, b) => {
    return (parseInt(field_positions[a]) || 0) - (parseInt(field_positions[b]) || 0)
  }))

  console.log({ inputFields })

  return (
    <Fragment>
      {map(inputFields, (type, field) => {
        const header = useSelector(state => state[formMode].field_headers && state[formMode].field_headers[field]) // fieldAttributes.headers
        return <Fragment key={field}>
          {header && <small className={classNames("form-text text-muted", { "offset-md-3 mb-1 pl-0 pl-md-2 col-md-8": formFieldStyle === "boostrap_horizontal" })}>
            <RenderedHtmlContent html={header} />
          </small>}
          <FormField type={type} field={field} tagOwner={tagOwner} formMode={formMode} />
        </Fragment>
      })}
    </Fragment>
  )
}

export default FormFields;
